import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie } from 'lucide-react';
import { getConsent, setConsent } from '@/lib/consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      setVisible(true);
    }
  }, []);

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-card/95 backdrop-blur-xl border-t border-border" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center gap-4">
        <Cookie className="w-5 h-5 text-primary shrink-0 hidden sm:block" />
        <p className="text-sm text-muted-foreground text-center sm:text-left flex-1">
          We use essential cookies to run Poettik. With your consent we also use the
          Meta (Facebook) Pixel to measure our advertising. See our{' '}
          <Link to="/cookies" className="text-primary hover:underline">Cookie Policy</Link> and{' '}
          <Link to="/privacy" className="text-primary hover:underline">Privacy Policy</Link>.
        </p>
        <div className="flex gap-2 shrink-0">
          <Button size="sm" variant="outline" onClick={() => choose('rejected')} data-testid="cookie-reject">
            Reject non-essential
          </Button>
          <Button size="sm" variant="premium" onClick={() => choose('accepted')} data-testid="cookie-accept">
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
